/* unplugin-vue-components disabled */import script from "./Member.vue?vue&type=script&setup=true&lang=js"
export * from "./Member.vue?vue&type=script&setup=true&lang=js"

import "./Member.vue?vue&type=style&index=0&id=01aaa2c5&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01aaa2c5"]])

export default __exports__